import React from 'react';
import styled from 'styled-components';

import { DropdownMenu } from '../../../components/modals/dropdown-menu/DropdownMenu';
import { Project, ProjectPriority } from '../../../app/entities';
import { UrgentPriorityIcon } from '../../../components/icons/urgent-priority';
import { TaskPropertyButton } from '../../tasks/components/task-property.button';

type PrioritySelectorProps = {
  onChange?: (newStatus: ProjectPriority) => void;
  priority?: ProjectPriority;
  isViewOnly?: boolean;
  withTitle?: boolean;
  className?: string;

  trigger?: React.ReactElement;
};

export const PrioritySelector: React.FC<PrioritySelectorProps> = ({
  onChange,
  priority = ProjectPriority.NO_PRIORITY,
  isViewOnly,
  withTitle,
  className,
  trigger,
}) => {
  if (isViewOnly) {
    return trigger ? (
      trigger
    ) : (
      <TaskPropertyButton
        icon={<PriorityIcon priority={priority} />}
        label={withTitle ? Project.PriorityMapper[priority].title : ''}
        isActive={!!priority}
        isDisabled={isViewOnly}
      />
    );
  }

  return (
    <DropdownMenu
      modal
      items={Project.PriorityArray.map(([key, { title }]) => ({
        title,
        onSelect: () => onChange?.(Number(key) as ProjectPriority),
        icon: <PriorityIcon priority={Number(key) as ProjectPriority} />,
      }))}
      align="start"
      className={className}
      trigger={
        <div>
          {trigger ? (
            trigger
          ) : (
            <TaskPropertyButton
              icon={<PriorityIcon priority={priority} />}
              label={withTitle ? Project.PriorityMapper[priority].title : ''}
              isActive={!!priority}
            />
          )}
        </div>
      }
      disabled={isViewOnly}
    />
  );
};

export const PriorityIcon = ({ priority }: { priority: ProjectPriority }) => (
  <Icon>
    {priority !== ProjectPriority.URGENT ? (
      <>
        <span data-priority={`${priority}`} />
        <span data-priority={`${priority}`} />
        <span data-priority={`${priority}`} />
      </>
    ) : (
      <UrgentPriorityIcon />
    )}
  </Icon>
);

const Icon = styled.div`
  display: flex;
  gap: 0.2rem;
  align-items: end;

  & span {
    width: 0.3rem;
    height: 0.6rem;
    border-radius: 0.1rem;
    background-color: #31343c;

    &:nth-child(1) {
      &[data-priority='1'],
      &[data-priority='2'],
      &[data-priority='3'] {
        background-color: #7a8296;
      }
    }

    &:nth-child(2) {
      height: 0.9rem;

      &[data-priority='2'],
      &[data-priority='3'] {
        background-color: #7a8296;
      }
    }

    &:nth-child(3) {
      height: 1.2rem;

      &[data-priority='3'] {
        background-color: #7a8296;
      }
    }
  }
`;
